// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"401c2bb4","375":"59ab31c3","695":"f41a6609","800":"805c2f22"}[chunkId] + ".chunk.js";
};